import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, SearchIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { landingImages } from '../../data/landingVisual';
interface FinalCTAProps {
  authenticated: boolean;
  username?: string;
}
export function FinalCTA({
  authenticated,
  username
}: FinalCTAProps) {
  return <section aria-labelledby="final-cta-heading" className="bg-canvas pb-16 lg:pb-20" data-id="element-2295" data-mp="2t65adq30yh0y">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-2296" data-mp="25j6zr91l63ay">
        <div className="relative overflow-hidden rounded-panel bg-brand-800" data-id="element-2297" data-mp="20k40k58aeraw">
          <img src={landingImages.ctaStudents} alt="" loading="lazy" className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover md:block" data-id="element-2298" data-mp="2eaz3z200og73" />
          {/* Keeps the headline legible where it crosses the photograph. */}
          <div aria-hidden className="absolute inset-0 hidden bg-gradient-to-r from-brand-800 via-brand-800/95 to-transparent md:block" data-id="element-2299" data-mp="1lsboq37pbvdx" />

          <div className="relative px-6 py-10 sm:px-10 lg:py-14 md:max-w-[58%]" data-id="element-2300" data-mp="1bb537kmxwied">
            <h2 id="final-cta-heading" className="text-h2 font-bold tracking-tight text-white" data-id="element-2301" data-mp="1g9gf00wsp2z8">
              Your campus is already changing.
              <br data-id="element-2302" data-mp="1l3u4xnsouhwi" />
              Be part of it.
            </h2>
            <p className="mt-4 max-w-[48ch] text-body leading-7 text-brand-100" data-id="element-2303" data-mp="1q01bniswrxfi">
              Create your Campuzon account and bring your academic, campus and everyday experiences
              together.
            </p>
            <div className="mt-7 flex flex-wrap gap-3" data-id="element-2304" data-mp="xdzsh7ca6vcs">
              {authenticated ? <Link to="/" data-id="element-2305" data-mp="129oxhq72l4gh">
                  <Button variant="secondary" className="border-white bg-white text-brand-800 hover:bg-brand-50" icon={<ArrowRightIcon className="h-5 w-5" data-id="element-2307" data-mp="2dpvmjuto3bx4" />} data-id="element-2306" data-mp="179tctcw8rt54">
                    Continue as @{username}
                  </Button>
                </Link> : <Link to="/register" data-id="element-2308" data-mp="ilffmrcqnna8">
                  <Button variant="secondary" className="border-white bg-white text-brand-800 hover:bg-brand-50" icon={<ArrowRightIcon className="h-5 w-5" data-id="element-2310" data-mp="rn5902q6kwan" />} data-id="element-2309" data-mp="dnw4w1f91sn1">
                    Create your account
                  </Button>
                </Link>}
              <Link to="/welcome/campuses" data-id="element-2311" data-mp="3w2y9wtlofqj2">
                <Button variant="secondary" className="border-white/40 bg-transparent text-white hover:bg-white/10 hover:text-white" icon={<SearchIcon className="h-5 w-5" data-id="element-2313" data-mp="8q40i7xf4e1y" />} data-id="element-2312" data-mp="3vzit9mccu9fj">
                  Explore Campuzon
                </Button>
              </Link>
            </div>
          </div>

          {/* On narrow screens the photograph sits below rather than behind. */}
          <img src={landingImages.ctaStudents} alt="A group of university students looking at a phone together on campus" loading="lazy" className="h-48 w-full object-cover md:hidden" data-id="element-2314" data-mp="38d3ymgh0aa0x" />
        </div>
      </div>
    </section>;
}